<template>
  <div class="error">
    <div class="error-box">
      <h1 class="error-title">{{this.$route.name}}</h1>
      <p class="error-text" v-if="this.$route.name.toLowerCase() === 'error404'">Strona nie została znaleziona</p>
      <p
        class="error-text"
        v-if="this.$route.name.toLowerCase() === 'error403'"
      >Strona wymaga uprawnień uprawnień</p>
      <a @click="backToWebsite()" class="error-link" to="/login">
        <b-button variant="primary">Powrót</b-button>
      </a>
    </div>
  </div>
</template>


<script>
export default {
  name: "TheError",
  methods: {
    backToWebsite(){
      window.history.back()
      // this.$router.back();
    }
  }
};
</script>